global?.modules?.set({
  name: 'accordion',
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    initAccordion({ containerSelector: '.accordion-container', options: { duration: 3000, showMultiple: false } });

    initAccordion({
      containerSelector: '.accordion-container-price',
      options: { duration: 300, showMultiple: false },
    });

    initAccordion({ containerSelector: '.accordion-container-faq', options: { duration: 300, showMultiple: false } });

    initAccordion({
      containerSelector: '.accordion-container-promotion',
      options: { duration: 300, showMultiple: false },
    });
  },
});

function initAccordion({ containerSelector, options = {} }) {
  const elements = Array.from(document.querySelectorAll(containerSelector));
  new Accordion(elements, options);
}
